import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.management_api.locales_caja_management;


// Helper function to configure the Axios instance
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Cached API wrapper for this namespace/group
const cachedApi = wrapAxiosInstance(api, {
    namespace: 'management_api',
    group: 'locales_caja_management',
    defaultTtl: '5m',
    hashLargeSegments: true,
    emitMeta: true,
});

// /GetLocalCajaManagement/<int:local_id>

export const getLocalCajaManagement = async (localId: number,userId:number) => {
    return await api.get(`/GetLocalCajaManagement/${localId}/${userId}`);
}

// /OpenLocalCaja/<int:user_id>/<int:workstation_id>

export const openLocalCaja = async (userId: number, workstationId: number, amount:number) => {
    const res = await api.put(`/OpenLocalCaja/${userId}/${workstationId}`, {
        initial_amount: amount
    });
    await cachedApi.clear();
    return res;
}

// /CloseLocalCaja/<int:user_id>/<int:workstation_id

export const closeLocalCaja = async (userId: number, workstationId: number,amount:number) => {
    const res = await api.put(`/CloseLocalCaja/${userId}/${workstationId}`, {
        final_amount: amount
    });
    await cachedApi.clear();
    return res;
}

// /LocalIsOpen/<int:local_id>

export const localIsOpen = async (localId: number) => {
    return await cachedApi.get(`/LocalIsOpen/${localId}`, undefined, { ttl: '15s' });
}


export const getLocalCajaManagementByLocalId = async (localId: number) => {
    return await cachedApi.get(`/GetLocalCajaManagementByLocalId/${localId}`, undefined, { ttl: '3m' });
}

export const cajaHaveMoneyWithWorkstationId = async (workstationId: number) => {
    return await api.get(`/CajaHaveMoneyWithWorkstationId/${workstationId}`);
};

export const moveMoneyFromCajaToCaja = async (
    fromWorkstationId: number,
    toWorkstationId: number
) => {
    const res = await api.post(
        `/MoveMoneyFromCajaToCaja/${fromWorkstationId}/${toWorkstationId}`
    );
    await cachedApi.clear();
    return res;
};
